module.exports = __webpack_public_path__ + "assets/static/png/sim-card-red.d49c86f1c88e69bcf4495ceb0bf9a786.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/sim-card-red.png
 ** module id = 520
 ** module chunks = 1
 **/